import {
  FormControl,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  autoCompleteSelectOptionsFormat,
  extractDataGroup,
  extractSelectedValues,
  getTimeStampFilterItem,
  selectedListValues,
} from "../../../../utility/helper";
import { listItemProp } from "utility/types";
import MultiSelectAutoCompleteV1, { ChildComponentRef } from "shared-component/autocomplete-checkbox-multiple-v1";
import { useEffect, useRef, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

dayjs.extend(utc);

const CdadHeaderSignalsFilterComponent = (props: any) => {
  const childRef = useRef<ChildComponentRef>({ clearSelection: () => { } });
  const [fiftyOneFSignalFilterData, setFiftyOneFSignalFilterData] = useState<string[]>(extractDataGroup(props.unNestedParamData, "list_51FLabels") || []);
  const [CANSignalFilterData, setCANSignalFilterData] = useState<string[]>(extractDataGroup(props.unNestedParamData, "list_CanLabels") || []);
  const defaultMin_Timestamp = extractDataGroup(props.unNestedParamData, "min_timestamp");
  const defaultMax_Timestamp = extractDataGroup(props.unNestedParamData, "max_timestamp");
  const minDateValue = getTimeStampFilterItem(
    props?.data,
    "min_timestamp",
    "min"
  );
  const maxDateValue = getTimeStampFilterItem(
    props?.data,
    "max_timestamp",
    "max"
  );

  const handleDateTimeChange = (newValue: any, title: string) => {
    const date = newValue.$d;
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
        .getHours()
        .toString()
        .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date
          .getSeconds()
          .toString()
          .padStart(2, "0")}`;
    props.getUpdatedList({
      title: title,
      value: formattedDate,
    });
  };



  const handle51FSignalSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    setFiftyOneFSignalFilterData(
      value
    );
    props.getUpdatedList({
      title: "list_51FLabels",
      value: value,
    });
    // Determine whether unNestDataEnable should be true or false
    const isUnNestDataEnable = value.length === 0;

    // Call the callback function from props to update unNestDataEnable in the parent component
    props.updateUnNestDataEnable(isUnNestDataEnable);
  }

  const handleCANSignalSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    setCANSignalFilterData(
      value
    );
    props.getUpdatedList({
      title: "list_CanLabels",
      value: value,
    });
    // Determine whether unNestDataEnable should be true or false
    const isUnNestDataEnable = value.length === 0;

    // Call the callback function from props to update unNestDataEnable in the parent component
    props.updateUnNestDataEnable(isUnNestDataEnable);
  }

  useEffect(() => {
    if (fiftyOneFSignalFilterData?.length > 0 || CANSignalFilterData?.length > 0) {
      props.updateUnNestDataEnable(false);
    }
  }, [fiftyOneFSignalFilterData, CANSignalFilterData, props])

  return (
    <div style={{ display: "flex", flexWrap: "wrap", paddingTop: "1rem", justifyContent: "flex-start" }}>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={fiftyOneFSignalFilterData?.length > 0 ? fiftyOneFSignalFilterData?.toString() : "Select / Search 51F Signals"} placement="right" >
          <FormControl style={{ width: "210px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props?.FiftyOneSignalData)}
              label="Select / Search 51F Signals"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleCANSignalSelection(value)
                handle51FSignalSelection(value)
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(fiftyOneFSignalFilterData)}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={CANSignalFilterData?.length > 0 ? CANSignalFilterData?.toString() : "Select / Search CAN300 Signals"} placement="right">
          <FormControl style={{ width: "215px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props?.canSignalData)}
              label="Select / Search CAN300 Signals"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleCANSignalSelection(value)
                handleCANSignalSelection(value)
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(CANSignalFilterData)}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div style={{ padding: "8px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {defaultMin_Timestamp ? <DateTimePicker
            label="Start Date Filter"
            minDate={dayjs(minDateValue)}
            maxDate={dayjs(maxDateValue)}
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            defaultValue={dayjs(defaultMin_Timestamp?.replace(" ", "T"))}
            onChange={(newValue: any) =>
              handleDateTimeChange(newValue, "min_timestamp")
            }
            sx={{
              width: "210px",
              '& .MuiInputLabel-root': {
                fontSize: '12px', // Change label font size here
              },
              '& .MuiInputBase-input': {
                fontSize: '12px', // Change input font size here
              },
            }}
          /> :
            <DateTimePicker
              label="Start Date Filter"
              minDate={dayjs(minDateValue)}
              maxDate={dayjs(maxDateValue)}
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
              onChange={(newValue: any) =>
                handleDateTimeChange(newValue, "min_timestamp")
              }
              sx={{
                width: "210px",
                '& .MuiInputLabel-root': {
                  fontSize: '12px', // Change label font size here
                },
                '& .MuiInputBase-input': {
                  fontSize: '12px', // Change input font size here
                },
              }}
            />}
        </LocalizationProvider>
      </div>
      <div style={{ padding: "8px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {defaultMax_Timestamp ? <DateTimePicker
            label={defaultMax_Timestamp ? '' : "End Date Filter"}
            minDate={dayjs(minDateValue)}
            maxDate={dayjs(maxDateValue)}
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            defaultValue={dayjs(defaultMax_Timestamp?.replace(" ", "T"))}
            onChange={(newValue: any) =>
              handleDateTimeChange(newValue, "max_timestamp")
            }
            sx={{
              width: "210px",
              '& .MuiInputLabel-root': {
                fontSize: '12px', // Change label font size here
              },
              '& .MuiInputBase-input': {
                fontSize: '12px', // Change input font size here
              },
            }}
          /> :
            <DateTimePicker
              label={"End Date Filter"}
              minDate={dayjs(minDateValue)}
              maxDate={dayjs(maxDateValue)}
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
              onChange={(newValue: any) =>
                handleDateTimeChange(newValue, "max_timestamp")
              }
              sx={{
                width: "210px",
                '& .MuiInputLabel-root': {
                  fontSize: '12px', // Change label font size here
                },
                '& .MuiInputBase-input': {
                  fontSize: '12px', // Change input font size here
                },
              }}
            />}
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default CdadHeaderSignalsFilterComponent;
